import { Directive, ElementRef, HostListener, Output, EventEmitter, Input } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective {

  constructor(private elementRef: ElementRef) { }

  @Input() forbidTrigger: boolean = false;
  @Input() excludeClass?: string;
  @Output() appClickOutside = new EventEmitter<MouseEvent>();

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) { return; }
    if (this.forbidTrigger) { return; }

    if (this.excludeClass && targetElement.closest(`.${this.excludeClass}`) !== null) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) { this.appClickOutside.emit(event); }
  }
}
